import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import el from './locales/el.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';

const resources = {
  en: { translation: en },
  el: { translation: el },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'el', 'fr', 'es', 'de'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    }
  });

export const languages = [
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/gb.png', flagCode: 'gb' },
  { code: 'el', name: 'Ελληνικά', flag: 'https://flagcdn.com/w40/gr.png', flagCode: 'gr' },
  { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/w40/fr.png', flagCode: 'fr' },
  { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w40/es.png', flagCode: 'es' },
  { code: 'de', name: 'Deutsch', flag: 'https://flagcdn.com/w40/de.png', flagCode: 'de' }
];

export default i18n;
